export const KEYBOARD_ROW_GAP = "__ROW_GAP__";
export const KEYBOARD_GROUP_SEPARATOR = "|";

export const keyboardLayouts = {
  japanese: [
    "わらやまはなたさかあ".split(""),
    "をり　みひにちしきい".split(""),
    "んるゆむふぬつすくう".split(""),
    "ーれ　めへねてせけえ".split(""),
    "　ろよもほのとそこお".split(""),
    [KEYBOARD_ROW_GAP],
    // 濁点・半濁点は文字キーの列から外し、小書き文字と同じ補助キーの行にまとめる
    "゛゜|ょゅゃっ|ぉぇぅぃぁ".split(""),
  ],
  english: [
    "1234567890".split(""),
    [KEYBOARD_ROW_GAP],
    "QWERTYUIOP".split(""),
    "ASDFGHJKL".split(""),
    "ZXCVBNM　-&".split(""),
  ],
  number: ["123".split(""), "456".split(""), "789".split(""), "0".split("")],
} as const;

export type KeyboardLanguage = keyof typeof keyboardLayouts;
